import React from "react";
import "./RulesAndRegulations.css";

export default function RulesAndRegulations({
  heroImage = "/images/background/3.jpg",
}) {
  return (
    <section className="rules-wrap">
      {/* Hero */}
      <div
        className="rules-hero"
        style={{ backgroundImage: `url('${heroImage}')` }}
      >
        <div className="auto-container">
          <div className="rules-subtitle">Rules And Regulations</div>
          <h1 className="rules-title">Rules &amp; Regulations</h1>
        </div>
      </div>

      {/* Body */}
      <div className="auto-container">
        <div className="rules-body">
          {/* TOC */}
          <aside className="rules-toc">
            <div className="rules-card rules-card--toc">
              <div className="rules-card-title">On this page</div>
              <nav>
                <a href="#overview">Overview</a>
                <a href="#eviction">Grounds for Eviction</a>
                <a href="#general">General Rules</a>
              </nav>
            </div>
          </aside>

          {/* Content */}
          <main className="rules-content">
            {/* Overview */}
            <article id="overview" className="rules-card">
              <h2 className="rules-card-title">Overview</h2>
              <p>
                The owners are authorized to evict any resident guest from any
                room, if in their opinion; such resident paying guest/person
                violates the rules, discipline or disturbs the peace. The
                decision of the owner shall be final in such cases.
              </p>
              <p>
                The paying guest has to fill up a police information form and
                submit their photo identity proof along with two passport size
                photographs to the owner. The identity proof would include a
                Smart card, the voter identity card, employment card, passport,
                adhar card or any other photo identity issued by a recognized
                authority.
              </p>
            </article>

            {/* Grounds for Eviction */}
            <article id="eviction" className="rules-card">
              <h2 className="rules-card-title">
                The owners are authorized to evict any resident guest from any
                room, if a resident fails in complying with any one of the
                following:
              </h2>
              <ul className="rules-list rules-list--ban">
                <li>Non - payment of dues within the due dates.</li>
                <li>Bringing guests without permission (illegal)</li>
                <li>Indulging in Anti - Social activities in the PG accommodation.</li>
                <li>Mischief causing damage to the PG accommodation property.</li>
                <li>If PG resident is continuously absent for 7 days without prior permission.</li>
                <li>Any misconduct or misbehavior with fellow PG resident/Owner.</li>
                <li>Any other complaint objectionable</li>
                <li>Ragging is strictly prohibited</li>
              </ul>
            </article>

            {/* General Rules */}
            <article id="general" className="rules-card">
              <h2 className="rules-card-title">
                GENERAL RULES AND REGULATIONS FOR PAYING GUEST RESIDENTS
              </h2>
              <ul className="rules-list">
                <li>
                  No relatives, friends or resident guests are allowed to keep
                  any vehicle in the parking premises.
                </li>
                <li>
                  Any act of intimidation or violence, willful damage to
                  property or drunken and riotous behavior constitutes an
                  offence. If anybody is found to do so, she shall be liable for
                  expulsion.
                </li>
                <li>
                  If they are found indulged in these activities they will be
                  expelled without serving any notice in this regard and pending
                  disciplinary action.
                </li>
                <li>
                  Use of narcotics, consumption of alcoholic beverages, Smoking
                  and gambling are strictly prohibited.
                </li>
                <li>
                  Misbehavior or Indulging in a row with owners / security staff
                  will be treated as an offence and will be liable for expulsion.
                </li>
                <li>
                  Resident guests shall be required to seek permission from the
                  owners before leaving for a leave.
                </li>
                <li>
                  All resident guests must be back in the premises by 10.30 p.m.;
                  necessary disciplinary action will be taken against the
                  defaulters.
                </li>
                <li>
                  No family members or friends of paying guests are permitted to
                  visit the room.
                </li>
                <li>
                  The PG inmates should take care for the safety of their
                  belongings inside the room. The owner shall not be responsible
                  for any such losses. Items like jewelry, costly watches and
                  mobile phones, laptops must not to be kept open inside the room.
                </li>
                <li>
                  Use of room heaters, electric irons and any other electrical
                  appliances other than cell phone charger, laptop charger are
                  not permitted.
                </li>
                <li>
                  Display of any type of posters, calendars, and other material
                  on the wall inside the allotted rooms is strictly prohibited.
                  Anyone found doing so shall be fined Rs. 3000/- for subsequent
                  offences and at last expulsion.
                </li>
                <li>
                  Cooking of food of any sort inside the PG accommodation is
                  strictly prohibited.
                </li>
                <li>
                  One month prior written notice must be given by resident guests
                  to the owners when vacating the premises, without any default.
                </li>
                <li>
                  PG residents should take away all their belongings from the
                  premises, before leaving the PG accommodation and must give
                  clean and vacant possession.
                </li>
                <li>
                  Deposit amount will not be adjusted as accommodation charges.
                  Security deposit will be refunded at the time of vacating the
                  room.
                </li>
                <li>
                  In case a resident guest vacates her room before completion of
                  the month, she will be bound to pay the accommodation charges
                  for the whole month. The accommodation charges are charged from
                  first day of the month to last day of the month
                </li>
              </ul>
            </article>

            {/* Footer note */}
            <div className="rules-note">
              Please read carefully. By staying at the PG, you agree to abide by
              these rules and any updates communicated by the owners.
            </div>
          </main>
        </div>
      </div>
    </section>
  );
}
